"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { InputErrorMessage } from "../../Typography/InputErrorMessage";
import { CustomDropdownOption } from ".";
import {
    INPUT_FIELD_CLASS,
    INPUT_FIELD_ERROR,
    NEW_INPUT_CLASS,
} from "../../../../public/Constants/EnumConstants";
import { DropdownArrowDown } from "../../../../public/Theme";
import { SELECT_TEXT, SHORTEN_WORDS } from "./constants";
import {
    INPUT_CONTAINER,
    LABEL,
    DROPDOWN_CARROT_CLASS,
    DROPDOWN_OPTIONS_CONTAINER,
    DROPDOWN_OPTIONS_INNER_CONTAINER,
    FIELD_TEXT_CLASS,
    RELATIVE_CLASS,
    DROPDOWN_OPTIONS_CLOSE,
    DROPDOWN_OPTIONS_OPEN,
    CARROT_CLASS,
    CARROT_ROTATE,
} from "./styles";
import ErrorTextWithIcon from "../../Typography/ErrorTextWithIcon/ErrorTextWithIcon";

const CustomDropdownField = ({
    disabled,
    label,
    options,
    setButtonDisabled,
    showIcons,
    setValue,
    field,
    value,
    errors,
}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedValue, setSelectedValue] = useState(SHORTEN_WORDS(value));

    const inputFieldClass = errors?.[field]?.message
        ? INPUT_FIELD_ERROR
        : INPUT_FIELD_CLASS;

    const onBlurHandle = (e) => {
        if (!e?.currentTarget?.contains(e?.relatedTarget)) {
            setShowDropdown(false);
        }
    };
    useEffect(() => {
        typeof value === "string" && setSelectedValue(SHORTEN_WORDS(value));
    }, [value]);

    return (
        <div
            className={disabled ? "opacity-40" : ""}
            onBlur={(e) => onBlurHandle(e)}
        >
            <p className={"font-poppins font-light text-sm pb-1"}>{label}</p>
            <div
                className={`${inputFieldClass}  ${NEW_INPUT_CLASS} !rounded-none flex flex-col justify-center relative`}
                tabIndex={0}
                onClick={() => !disabled && setShowDropdown(!showDropdown)}
            >
                <p
                    className={`${!selectedValue ? "!text-[#666666]" : ""} whitespace-nowrap`}
                >
                    {selectedValue || SELECT_TEXT}
                </p>
                <div className={"absolute right-2"}>
                    <Image
                        height={24}
                        width={24}
                        className={`transition-all delay-50 duration-300 
                            ${showDropdown ? " rotate-180" : ""}`}
                        src={DropdownArrowDown}
                        alt="arrow icon"
                    />
                </div>
            </div>

            {
                <div
                    className={`relative z-20 shadow-dropdown-shadow transition-all delay-50 duration-300
                        ${
                            showDropdown
                                ? "h-full opacity-100"
                                : "h-0 opacity-0"
                        }`}
                    tabIndex={0}
                >
                    {showDropdown && (
                        <div
                            className={
                                "max-h-60 overflow-auto absolute bg-Primary_Background w-full border border-BORDER_GRAY flex flex-col"
                            }
                        >
                            {options?.map((item, index) => {
                                return (
                                    <CustomDropdownOption
                                        field={field}
                                        image={item?.media || item?.image}
                                        key={index}
                                        setSelectedValue={setSelectedValue}
                                        selectedValue={selectedValue}
                                        setValue={setValue}
                                        setShowDropdown={setShowDropdown}
                                        showIcons={showIcons}
                                        value={
                                            item?.title ||
                                            item?.label ||
                                            item?.name ||
                                            item?.text ||
                                            item
                                        }
                                        setButtonDisabled={setButtonDisabled}
                                    />
                                );
                            })}
                        </div>
                    )}
                </div>
            }
            <ErrorTextWithIcon
                showIcon={true}
                text={errors?.[field]?.message}
            />
        </div>
    );
};

export default CustomDropdownField;
